import React from 'react'
import { usePutRequest } from '../hooks/request'
import ServerError from './componentsFinance/common/ServerError'
import ManthlyBalanceItemForm from './ManthlyBalanceItemForm'
import { MANTHLY_RESULT_ITEM_DETAIL } from '../urls'
import ManthlyResultItemForm from './ManthlyResultItemForm'

export default function ManthlyResultItemUpdate({ onCancel, onSuccess, reportItem, finance, rotationId }) {
    const url = MANTHLY_RESULT_ITEM_DETAIL.replace('{id}', reportItem.id)
    const rotationItemUpdate = usePutRequest({ url })

    async function onSubmit(data) {
        const { success } = await rotationItemUpdate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <b>Изменить данные</b><br /><br />
            <ServerError error={rotationItemUpdate.error} />
            <ManthlyResultItemForm
                initialValues={reportItem}
                onSubmit={onSubmit}
                onCancel={onCancel}
                rotationId={rotationId}
                finance={finance}
                loading={rotationItemUpdate.loading} />
        </div>
    )
}
